<template>
  <div class="l-wrapper">
    <h2 class="c-heading">お問い合わせ</h2>
    <p class="c-description">
      下記の入力された内容をご確認のうえ、よろしければ「送信」ボタンを押してください。
      修正される場合は、「戻る」ボタンを押してください。
    </p>

    <div class="c-confirm">
      <p class="c-confirm__title">お名前</p>
      <p class="c-confirm__data">{{  requestBody.name  }}</p>
    </div>

    <div class="c-confirm">
      <p class="c-confirm__title">フリガナ</p>
      <p class="c-confirm__data">{{requestBody.kana}}</p>
    </div>

    <div class="c-confirm">
      <p class="c-confirm__title">メールアドレス</p>
      <p class="c-confirm__data">{{requestBody.email}}</p>
    </div>

    <div class="c-confirm">
      <p class="c-confirm__title">お問い合わせ内容</p>
      <p class="c-confirm__data">
        {{ requestBody.message }}
      </p>
    </div>

    <p v-if="err.isErr" class="p-errmsg">
      <span>
        <img
          src="@/assets/attention.png"
          alt="エラー"
          width="22"
          height="22"
        />
      </span>
      {{err.errMsg}}
    </p>

    <div class="c-buttons">
      <common-button
        class="u-mR10"
        :title="'送信'"
        :middle="true"
        :border_red="true"
        :font_size="'16px'"
        :font_bold="true"
        :width="'120px'"
        :callback="submit"
        :attr="[]"
        :disabled="isLoading"
        />
      <common-button
        class=""
        :title="'戻る'"
        :middle="true"
        :callback="toForm"
        :font_size="'16px'"
        :font_bold="true"
        :disabled="isLoading"
        :width="'120px'"
        :attr="[]"
        />
    </div>
  </div>
</template>

<script>
import CommonButton from '@/components/parts/button/CommonButton';
import axios from 'axios';
import { sendContactRequest } from '@/api/inquiry-email';

export default {
  name: 'ContactConfirm',
  components: {
    CommonButton,
  },
  data() {
    return {
      isLoading: false,
      err: {
        isErr: false,
        errMsg: '',
      },
    };
  },
  props: ['requestBody'],
  computed: {
    isPageChild: {
      get() {
        return this.isPage;
      },
      set(isPage) {
        this.$emit('input', isPage);
      },
    },
    isLoggedIn() {
      return this.$store.state.user;
    },
  },
  created() {},
  methods: {
    toForm() {
      this.isPageChild = 'form';
    },
    async submit() {
      this.err.isErr = false;
      this.err.errMsg = '';
      this.isLoading = true;

      try {
        const params = new URLSearchParams();
        params.append('message', this.requestBody.message);
        params.append('name', this.requestBody.name);
        params.append('email', this.requestBody.email);
        let uri;
        if (process.env.VUE_APP_ENV === 'prod') {
          uri = 'https://ki-group.jp/mitsukaru/contact.php'; // 本番環境
        } else {
          uri = 'https://ki-group.jp/mitsukaru/contact_dev.php';// 開発環境
        }

        await axios.post(uri, params, { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } });
        const request = {
          user: {
            name: this.requestBody.name,
            email: this.requestBody.email,
            isMember: !!(this.isLoggedIn),
          },
          message: this.requestBody.message,
        };
        await sendContactRequest(request);
        this.isPageChild = 'comp';
      } catch (e) {
        this.err.isErr = true;
        this.err.errMsg = 'エラーが発生しました。しばらく待ってからやり直してください。';
      } finally {
        // this.isLoading = false;
      }
    },
  },
};
</script>

<!-- Add 'scoped' attribute to limit CSS to this component only -->
<style scoped lang="scss">
@charset "UTF-8";
.l-wrapper {
  max-width: 559px;
  width: 100%;
  margin: 0 auto;
}

.c-heading {
  margin: 0 0 40px;
  font-size: 20px;
  font-weight: bold;
  color: #666;
  line-height: 1.5;
  font-family: "メイリオ", "Meiryo", sans-serif;
  text-align: center;
}

.c-description {
  font-size: 14px;
  color: #666;
  line-height: 2;
  font-family: "メイリオ", "Meiryo", sans-serif;
}

.c-confirm {
  margin-top: 24px;

  &__title {
    font-family: "メイリオ", "Meiryo", sans-serif;
    font-size: 16px;
    font-weight: bold;
    color: #666;
  }
  &__data {
    font-family: "メイリオ", "Meiryo", sans-serif;
    margin-top: 12px;
    font-size: 14px;
    color: #666;
    line-height: 2;
    word-break: break-all;
  }
}

.c-buttons {
  display: flex;
  justify-content: center;
  margin-top: 20px;
}

.u-mR10 {
  margin-right: 10px;
}

@media screen and (max-width: 767px) {
  .l-wrapper {
    max-width: 100%;
  }
  .c-heading {
    font-size: 18px;
    margin-bottom: 24px;
  }
  .c-description {
    margin-bottom: 32px;
  }
  .c-confirm {
    &__data {
      font-size: 16px;
      line-height: 1.2;
    }
  }
  .c-buttons {
    justify-content: end;
    margin-top: 34px;
  }
}

.p-errmsg {
  padding: 12px 0;
  font-size: 14px;
  display: flex;
  justify-content: center;
  color: red;
  align-items: center;
  margin: auto;

  img {
    margin-right: 12px;
  }
}
</style>
